// frontend/apps/demo/piwa-portfolio/src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n.config';
import { ThemeProvider } from './theme/theme.provider';
import App from './app.component';
import './index.css';

// Add retro startup sound effect (optional)
const playStartupSound = () => {
  const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQoGAAA=');
  audio.volume = 0.3;
  audio.play().catch(() => {
    // User hasn't interacted with page yet, that's fine
  });
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Play startup sound when app loads
window.addEventListener('load', playStartupSound);